/*!

=========================================================
* Material Dashboard React - v1.10.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// @material-ui/icons
import Dashboard from "@material-ui/icons/Dashboard";
import Person from "@material-ui/icons/Person";
// import LibraryBooks from "@material-ui/icons/LibraryBooks";
// import BubbleChart from "@material-ui/icons/BubbleChart";
// import LocationOn from "@material-ui/icons/LocationOn";
// import Notifications from "@material-ui/icons/Notifications";
// import Unarchive from "@material-ui/icons/Unarchive";
// import Language from "@material-ui/icons/Language";
// core components/views for Admin layout
import DashboardPage from "views/Dashboard/Dashboard.js";
import UserProfile from "views/UserProfile/UserProfile.js";
import Response from "views/AutomatonResponse/AutomatonResponse";
import GrammarPage from "views/Grammar/Grammar.jsx";
import GrammarPageResponse from "views/GrammarResponse/GrammarResponse.jsx";
// import About from "views/About/About.jsx";
import Login from "views/Login/Login";
import About from "views/About/About";
import Report from "views/Report/Report";
// import TableList from "views/TableList/TableList.js";
// import Typography from "views/Typography/Typography.js";
// import Icons from "views/Icons/Icons.js";
// import Maps from "views/Maps/Maps.js";
// import NotificationsPage from "views/Notifications/Notifications.js";
// import UpgradeToPro from "views/UpgradeToPro/UpgradeToPro.js";
// core components/views for RTL layout
import SimulateGrammar from "views/Simulate/SimulateGrammar.jsx";

const dashboardRoutes = [
  {
    path: "/about",
    name: "About",
    component: About,
    layout: "/admin",
  },
  {
    path: "/automaton",
    name: "Draw",
    icon: Dashboard,
    component: DashboardPage,
    layout: "/admin",
  },
  {
    path: "/profile",
    name: "User Profile",
    icon: Person,
    component: UserProfile,
    layout: "/admin",
  },
  {
    path: "/responseAutomaton",
    name: "Response automaton",

    component: Response,
    layout: "/admin",
  },
  {
    path: "/grammar",
    name: "grammar",
    component: GrammarPage,
    layout: "/admin",
  },
  {
    path: "/grammarResponse",
    name: "grammar response",
    component: GrammarPageResponse,
    layout: "/admin",
  },
  {
    path: "/simulateGrammar",
    name: "simulate grammar",
    component: SimulateGrammar,
    layout: "/admin",
  },
  {
    path: "/profile",
    name: "profile",
    component: UserProfile,
    layout: "/admin",
  },
  {
    path: "/reports",
    name: "reports",
    component: Report,
    layout: "/admin",
  },
  // {
  //   path: "/about",
  //   name: "about",
  //   component: About,
  //   layout: "/",
  // },
  {
    path: "/login",
    name: "login",
    component: Login,
    layout: "/",
  },
];

export default dashboardRoutes;
